function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ResultInfoComponent from "../../components/Results/ResultInfo";
function ResultInfo(props) {
  var count = useSelector(function (state) {
    var _state$dataset, _state$dataset$data, _state$dataset$data$i;
    return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : (_state$dataset$data = _state$dataset.data) === null || _state$dataset$data === void 0 ? void 0 : (_state$dataset$data$i = _state$dataset$data.info) === null || _state$dataset$data$i === void 0 ? void 0 : _state$dataset$data$i.count;
  });
  return /*#__PURE__*/React.createElement(ResultInfoComponent, _extends({
    count: count
  }, props));
}
export default ResultInfo;